import {useMemo} from 'react'

import type {PinControls} from './PinViewMenuItem'
import styles from './RepositoryViews.module.css'
import type {SavedView} from './types'
import {splitViewsByVisibility} from './views-visibility'
import {ViewsSection} from './ViewsSection'

type ViewsSectionsProps = {
  views: SavedView[]
  owner: string
  repo: string
  viewerCanManageViews?: boolean
  showPinControls?: boolean
  pinControls?: PinControls
}

export function ViewsSections({
  views,
  owner,
  repo,
  viewerCanManageViews = false,
  showPinControls = false,
  pinControls,
}: ViewsSectionsProps) {
  const {team, personal} = useMemo(() => splitViewsByVisibility(views), [views])

  const shared = {owner, repo, viewerCanManageViews, showPinControls, pinControls}

  return (
    <div className={styles.viewsSections}>
      <ViewsSection visibility="personal" views={personal} otherSectionsHaveViews={team.length > 0} {...shared} />
      <ViewsSection visibility="team" views={team} otherSectionsHaveViews={personal.length > 0} {...shared} />
    </div>
  )
}
